import React, { PropsWithChildren, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, useWindowDimensions, View, ViewStyle } from 'react-native';
import { Button, Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setAgePassed } from '@/state/modals';
import { AppText } from '@/components/AppText';

const styles = StyleSheet.create({
  modalContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
  },
  modalView: {
    backgroundColor: AppConsts.MAIN_COLOR2,
    padding: 20,
    gap: 20,
    borderWidth: 4,
    borderColor: AppConsts.COLOR7,
    alignItems: "center",
  },
  buttonsRow: {
    flexDirection: "row",
    gap: 20,
  },
  modalfyContainer: {
    backgroundColor: AppConsts.MAIN_COLOR2,
    padding: 20,
    gap: 20,
  },
});

interface Props {
};

export function AgeModalWeb({ }: Props) : React.ReactNode {

  const dispatch = useDispatch();
  const {height : screenHeight, width : screenWidth} = useWindowDimensions();

  const onYes = async () => {
    dispatch(setAgePassed(true));

    // Set an 'accessed' cookie across domains

    // No need to await on this and it's okay if this fails
    try {
      AppUtilities.fetchUnauthorized(
        "AgeModalWeb.onYes",
        "/rabbl/api/accessed",
        "POST",
        {
        }
      );
    } catch (e) {
      if (AppUtilities.DEBUGLEVEL.network) {
        AppUtilities.debug("Failed calling accessed API: " + e);
        AppUtilities.handleException(e, "AgeModalWeb.onYes");
      }
    }
  };

  const onNo = () => {
    if (AppUtilities.isWeb()) {
      AppUtils.webFullPageNavigate(AppUtils.createFrontendLink("/pages/minimumage"));
    }
  };

  let maxWidth = AppConsts.BASIC_MINIMUM_WIDTH;
  if (screenWidth > (maxWidth * 2.5)) {
    maxWidth *= 2;
  }

  return (
    <View style={[styles.modalContainer, { width: screenWidth, height: screenHeight }]}>
      <View style={[styles.modalView, { maxWidth: maxWidth }]}>
        <CustomText>Are you 18 years or older?</CustomText>

        <AppText>You must be 18 years or older to use Rabbl.</AppText>

        <View style={styles.buttonsRow}>
          <Button onPress={onYes}>Yes</Button>
          <Button onPress={onNo}>No</Button>
        </View>
      </View>
    </View>
  );
};
